import React from "react";
import { useAuth } from "../../context/AuthContext";

const PersonalInfo = () => {
  const { userProfile } = useAuth();
  return (
    <div className="personal-info">
      <p>
        {userProfile?.email ? (
          <>
            <span>Email</span>
            {userProfile?.email}
          </>
        ) : (
          <>
            <span>Phone</span>
            {userProfile?.countryCode} {userProfile?.phone}`
          </>
        )}
      </p>
      <p>
        <span>Name</span> {userProfile?.name}
      </p>
    </div>
  );
};

export default PersonalInfo;
